import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from '@mui/styles'
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Divider,
  Input,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide, Grid, Typography, CircularProgress } from '@mui/material';
import { compose } from "recompose";
import "./common.scss";
import { withSnackbar } from "notistack";
import classNames from "classnames";
import ClearIcon from "@mui/icons-material/Clear";
import { showSuccessNotification } from "common/helpers";
import { showErrorNotification } from "common/helpers";
import { AddUpdatePmaAdmin } from "services/agent";

import { propertyUtil } from "views/Pma/PropertyUtil";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PhotoEditProperty = (props) => {
  const {
    //representedOptions,
    editPropFormData,
    handleInputChange,
    openUploadMedia,
    onCloseFn,
    oldPropData,
    areaID,
    onEditFormSubmit,
    fromPhotoTable,
    agentData,
  } = props;
  console.log("edit property props", props.editPropFormData);
  const {
    isMemberOfTeam = false,
    agentLicenseNumber = null,
    teamMembers = [],
  } = agentData || {};
  const teamMember1License =
    isMemberOfTeam && teamMembers[0]?.agentLicenseNumber;
  const teamMember2License =
    isMemberOfTeam && teamMembers[1]?.agentLicenseNumber;

  const { formatSuffix } = propertyUtil;

  // let isListingAgent = false;

  // if (
  //   (!isMemberOfTeam &&
  //     agentLicenseNumber === editPropFormData.listingAgentLicenseID) ||
  //   (isMemberOfTeam &&
  //     (teamMember1License === editPropFormData.listingAgentLicenseID ||
  //       teamMember2License === editPropFormData.listingAgentLicenseID)) ||
  //   (editPropFormData.isCoListingAgent &&
  //     editPropFormData.isCoListingAgent === "true") ||
  //   editPropFormData.coListingAgents
  // ) {
  //   isListingAgent = true;
  // }
  // let isSellingAgent = false;
  // if (
  //   (!isMemberOfTeam &&
  //     agentLicenseNumber === editPropFormData.sellingAgentLicenseID) ||
  //   (isMemberOfTeam &&
  //     (teamMember1License === editPropFormData.sellingAgentLicenseID ||
  //       teamMember2License === editPropFormData.sellingAgentLicenseID)) ||
  //   (editPropFormData.isCoSellingAgent &&
  //     editPropFormData.isCoSellingAgent === "true")
  // ) {
  //   isSellingAgent = true;
  // }

  let mapOrder = [];
  if (editPropFormData.isBuyingAgent && editPropFormData.isSellingAgent) {
    mapOrder = ["Buyer/Seller", "Buyer", "Seller", "N/A"];
  } else if (editPropFormData.isBuyingAgent) {
    mapOrder = ["Buyer", "Seller", "N/A", "Buyer/Seller"];
  } else if (editPropFormData.isSellingAgent) {
    mapOrder = ["Seller", "N/A", "Buyer/Seller", "Buyer"];
  } else {
    mapOrder = ["N/A", "Buyer/Seller", "Buyer", "Seller"];
  }

  let oldRepresented =
    oldPropData.isBuyingAgent && oldPropData.isSellingAgent
      ? "Buyer/Seller"
      : oldPropData.isBuyingAgent
      ? "Buyer"
      : oldPropData.isSellingAgent
      ? "Seller"
      : "N/A";

  let currentRepresented =
    editPropFormData.isBuyingAgent && editPropFormData.isSellingAgent
      ? "Buyer/Seller"
      : editPropFormData.isBuyingAgent
      ? "Buyer"
      : editPropFormData.isSellingAgent
      ? "Seller"
      : "N/A";

  return (
    <Fragment>
      <Dialog
        open={true}
        //onClose={onCloseFn}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth={true}
        TransitionComponent={Transition}
      >
        <div
          className={`${
            fromPhotoTable
              ? "photo-table-photo-edit-property-container"
              : "photo-edit-property-container"
          }`}
        >
          <div className="photo-edit-property-title-container">
            <p className="photo-edit-property-title">Change Property Details</p>
            <div className="photo-edit-property-title-divider" />
            <div className="photo-edit-property-subtitle-text">
              You can change any property details by clicking the{" "}
              <div className="subtitle-edit-button"> edit</div> button under
              each field
            </div>
          </div>
          <div className="photo-edit-property-form old-props">
            <div className="photo-edit-property-form-title-container">
              <p className="photo-edit-property-form-title-text">
                Current Property Details{" "}
                <span className="long-dash-title">—</span> From the MLS
              </p>
              <div className="photo-edit-property-form-title-divider"></div>
            </div>
            <div className="photo-edit-property-form-body">
              <div className="photo-edit-form-body-col">
                <div className="photo-edit-form-thead">
                  <div className="represented-th">
                    <p>Represented</p>
                  </div>
                  <div className="address-th">Address</div>
                  {!fromPhotoTable && <div className="city-th">City</div>}
                  {oldPropData.status === "Sold" && (
                    <div className="sale-price-th">Sale Price</div>
                  )}
                  <div className="brokerage-th">Brokerage</div>
                  <div className="photo-th">
                    <p>MLS Photo</p>
                    <p>Shown Here</p>
                  </div>
                </div>
                <div className="photo-edit-form-input">
                  <div className="represented-td">
                    <div>{oldRepresented}</div>{" "}
                  </div>
                  <div className="address-td">
                    <div>
                      {" "}
                      {oldPropData.streetNumber === "-" ||
                      oldPropData.streetNumber === "0"
                        ? null
                        : oldPropData.streetNumber}{" "}
                      {oldPropData.streetName}{" "}
                      {oldPropData.streetSuffix &&
                        oldPropData.streetSuffix !== "-" &&
                        formatSuffix(oldPropData.streetSuffix, areaID)}
                      {oldPropData.propertyType === "Townhouse" &&
                      oldPropData.unitNumber !== "-"
                        ? `, #${oldPropData.unitNumber}`
                        : ""}
                    </div>
                  </div>
                  {!fromPhotoTable && (
                    <div className="city-name-td">
                      <div>{oldPropData.cityName && oldPropData.cityName}</div>
                    </div>
                  )}
                  {oldPropData.status === "Sold" && (
                    <div className="sale-price-td">
                      <div>
                        ${Number(oldPropData.salePrice).toLocaleString()}
                      </div>
                    </div>
                  )}

                  <div className="brokerage-name-td">
                    <div>{editPropFormData.brokerageName}</div>
                  </div>
                  <div className="photo-td">
                    <div className="photo-add-photo-container no-hover">
                      <img src={oldPropData.photoURL} alt="Home" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="photo-edit-property-form new-props">
            <div className="photo-edit-property-form-title-container">
              <p className="photo-edit-property-form-title-text">
                Make Changes to this property here:
              </p>
              <div className="photo-edit-property-form-title-divider"></div>
            </div>
            <div className="photo-edit-property-form-body">
              <div className="photo-edit-form-body-col">
                <div className="photo-edit-form-thead">
                  <div className="represented-th">
                    <p>Represented</p>
                  </div>
                  <div className="address-th">Address</div>
                  {!fromPhotoTable && <div className="city-th">City</div>}
                  {editPropFormData.status === "Sold" && (
                    <div className="sale-price-th">Sale Price</div>
                  )}
                  <div className="brokerage-th">Brokerage</div>
                  <div className="photo-th">
                    <p>Photo</p>
                  </div>
                </div>
                <div className="photo-edit-form-input">
                  <div className="represented-td">
                    <div
                      className={`prop-highlight-arrow-down ${
                        fromPhotoTable && "higher-prop-highlight-arrow-down"
                      }`}
                      onClick={props.handleRepresentedOptionsFunc}
                    ></div>
                    <div className="prop-highlight-options">
                      {mapOrder &&
                        mapOrder.map((option) => (
                          <div key={option}>{option}</div>
                        ))}
                    </div>
                  </div>
                  <div className="address-input-col address-td">
                    <input
                      type="text"
                      id="streetNumber"
                      name="streetNumber"
                      value={editPropFormData.streetNumber || ""}
                      onChange={handleInputChange}
                      placeholder="Street Number"
                    ></input>
                    <input
                      type="text"
                      id="streetName"
                      name="streetName"
                      value={editPropFormData.streetName || ""}
                      onChange={handleInputChange}
                      placeholder="Street Name"
                    ></input>
                    <input
                      type="text"
                      id="streetSuffix"
                      name="streetSuffix"
                      value={editPropFormData.streetSuffix || ""}
                      onChange={handleInputChange}
                      placeholder="Street Suffix"
                    ></input>

                    <input
                      type="text"
                      id="unitNumber"
                      name="unitNumber"
                      value={editPropFormData.unitNumber || ""}
                      onChange={handleInputChange}
                      placeholder="Unit Number"
                    ></input>
                  </div>
                  {!fromPhotoTable && (
                    <div className="city-name-td">
                      <input
                        type="text"
                        id="cityName"
                        name="cityName"
                        value={editPropFormData.cityName || ""}
                        onChange={handleInputChange}
                      ></input>
                    </div>
                  )}
                  {editPropFormData.status === "Sold" && (
                    <div className="sale-price-input sale-price-td">
                      <span className="sale-price-input-dollar">$</span>
                      <input
                        type="text"
                        id="sale-price"
                        name="salePrice"
                        value={
                          Number(editPropFormData.salePrice).toLocaleString() ||
                          ""
                        }
                        onChange={handleInputChange}
                      ></input>
                    </div>
                  )}

                  <div className="brokerage-name-td">
                    <input
                      type="text"
                      id="brokerage-name"
                      name="brokerageName"
                      value={editPropFormData.brokerageName || ""}
                      onChange={handleInputChange}
                    ></input>
                  </div>

                  <div className="photo-td">
                    {editPropFormData.justAdded ? (
                      <div>
                        <div className="photo-add-photo-container no-hover">
                          <img
                            src={editPropFormData.optimizedPhotoURL}
                            alt="Home"
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="photo-add-photo-container add-prop photo-td"
                        onClick={(event) =>
                          openUploadMedia(
                            oldPropData.displayOrder,
                            editPropFormData.photoURL
                          )
                        }
                      >
                        <p>Click to</p>
                        <p>Upload Photo</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="photo-edit-form-button-container">
            <div className="photo-edit-form-cancel-button" onClick={onCloseFn}>
              <p>Cancel</p>
            </div>
            <div
              className="photo-edit-form-submit-button"
              onClick={onEditFormSubmit}
            >
              <p>Submit</p>
            </div>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};

export default compose(withSnackbar)(PhotoEditProperty);
